/* template */
<template minapp="mpx" xlang="wxml"><div><div v-for="(item, index) in (passengerList)" class="passenger card-flex-wrap"><mpx-view @tap="selectPassenger(index)" class="card-flex-wrap passenger-btn"><div class="passenger-middle"><div class="passenger-name">{{ item.passenger_name }}</div><div class="passenger-type">{{ getPassengerType(item.passenger_type) }}</div><div class="passenger-number">{{ item.encrypt_id_no }}</div></div><es-icon size="18" name="angle-right" class="link-btn-icon display-inline-block" v-if="(showArrow)"/></mpx-view><mpx-image src="https://ut-static.udache.com/webx/sfc/suxvGlrGntfJ94ro0mihR.png" @tap="deletePassenger(item.id)" class="passenger-del"/></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m49ae47db"}'>
  @import '~@/mixins/stylus/color.styl'

.card-flex-wrap
  padding 0 12px
  display flex
  justify-content space-between
  font-size 14px
  .flex-left, .flex-right
    display flex
    align-items center
.passenger
  padding 16px 4px 16px 0px !important
  box-sizing border-box
  justify-content space-between
  align-items center
  border-bottom 0.5px solid #D1DBE9
  &:first-child
    border-radius 8px 8px 0 0
  &-btn
    flex 1
    justify-content flex-end
    align-items center
    padding 0
  &-middle
    flex 1
    display flex
    align-items center
  &-type
    font-size 10px
    line-height 10px
    color #999999
    margin-right 16px
    padding 2px
    font-family PingFangSC-Regular
    position relative
    &:after
      position absolute
      content: ""
      width 200%
      height 200%
      border 1px solid #ccc
      transform-origin: 0 0
      transform: scale(0.5)
      border-radius 6px
      top 0
      left 0
  &-name
    font-family PingFangSC-Medium
    font-size 16px
    line-height 16px
    color #000
    font-weight normal
    margin-right 4px
  &-number
    font-family PingFangSC-Regular
    font-size 16px
    line-height 16px
    color #666
  &-add
    width 100%
    background-color #edf4ff
    border-radius 8px
    margin 0 auto
    font-size 14px
    line-height 44px
    text-align center
    color $train-color-theme-blue
    &-icon
      display inline-block
      margin-right 4px
      vertical-align bottom
    &-text
      font-weight 700
  &-del
    height 15px
    width 15px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m49ae47db"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./passenger-make-order-card.mpx.js?isComponent&outputPath=components%2Fpassenger-make-order-card49ae47db%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./passenger-make-order-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fpassenger-make-order-card49ae47db%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m49ae47db"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/passenger-make-order-card49ae47db/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-checkbox':getComponent(require("../../../es-mpx-ui/lib/checkbox/index.mpx?isComponent&outputPath=components%2Findex8e1a7e44%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
